import { useState } from "react";
import { Link } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { graphqlClient } from "@/lib/graphql";

const REQUEST_PASSWORD_RESET_MUTATION = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email) {
      success
      errors
    }
  }
`;

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const mutation = useMutation({
    mutationFn: (vars: { email: string }) =>
      graphqlClient.request<{
        requestPasswordReset: { success: boolean; errors: string[] };
      }>(REQUEST_PASSWORD_RESET_MUTATION, vars),
    onSuccess: () => {
      setSubmitted(true);
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutation.mutate({ email });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <Link to="/" className="inline-flex items-center gap-2">
            <img src="/icon.svg" alt="Boardo" className="h-12 w-12" />
            <span className="text-2xl font-bold text-primary-800">Boardo</span>
          </Link>
          <h1 className="mt-6 text-2xl font-bold text-gray-900">
            Pamiršote slaptažodį?
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Įveskite savo el. pašto adresą ir mes atsiųsime nuorodą
            slaptažodžiui atkurti.
          </p>
        </div>

        <div className="card p-8">
          {submitted ? (
            <div className="rounded-lg bg-green-50 p-4 text-sm text-green-700">
              Jei ši el. pašto adresą egzistuoja mūsų sistemoje, atsiuntėme
              slaptažodžio atkūrimo nuorodą.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">
                  El. paštas
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={mutation.isPending}
                className="btn-primary w-full"
              >
                {mutation.isPending ? "Siunčiama..." : "Siųsti nuorodą"}
              </button>
            </form>
          )}

          <div className="mt-6 text-center">
            <Link
              to="/login"
              className="text-sm text-primary-800 hover:text-primary-700"
            >
              Grįžti į prisijungimą
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
